/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';

function setUpCheckout() {
    if ($('.js-cancel-address').length !== 0) {
        $('.checkout-step:not(.js-current-step) .step-title').addClass('not-allowed');
    }

    $('.js-terms a').on('click', (event) => {
        event.preventDefault();
        var url = $(event.target).attr('href');
        if (url) {
            url += `?content_only=1`;
            $.get(url, (content) => {
                $('#modal').find('.js-modal-content').html($(content).find('.page-content--cms').contents());
            }).fail((resp) => {
                prestashop.emit('handleError', {
                    eventType: 'clickTerms',
                    resp: resp
                });
            });
        }

        $('#modal').modal('show');
    });

    $('.js-gift-checkbox').on('click', (event) => {
        $('#gift').collapse('toggle');
    });
}

$(document).ready(() => {
    const paymentFormSelector = '#payment-form';
    $(document).on('submit', paymentFormSelector, function () {
        const form = $(this);
        $.ajax({
            url: 'module/seq_magasins/ajax',
            type: 'POST',
            cache: false,
            data: {
                ajax: true,
                action: 'checkDateBeforePayment',
            },
            success: function (message) {
                const messageFormat = JSON.parse(message);
                if (messageFormat.success) {
                    $(document).off('submit', paymentFormSelector);
                    form.submit();
                } else {
                    if ($('#confirmation-error').is(":visible") === false) {
                        $('#confirmation-error').show();
                    }
                    const errorMsgStr = () => {
                        let message = "<ul>";
                        for (let index = 0; index < messageFormat.messages.length; index++) {
                            message += "<li>" + messageFormat.messages[index] + "</li>";
                        }
                        message += "</ul>";
                        return message;
                    };
                    $('#confirmation-error-message').html(errorMsgStr);
                    if(messageFormat.refresh) {
                        function sleep(ms) {
                            return new Promise(resolve => setTimeout(resolve, ms));
                          }
                        sleep(4000).then(() => {  window.location.reload(); });
                    }
                }
            }
        });
        return false;
    });
    if ($('body#checkout').length === 1) {
        setUpCheckout();
    }

    prestashop.on('updatedDeliveryForm', (params) => {
        if (typeof params.deliveryOption === 'undefined' || 0 === params.deliveryOption.length) {
            return;
        }
        // Hide all carrier extra content ...
        $(".carrier-extra-content").hide();
        // and show the one related to the selected carrier
        params.deliveryOption.next(".carrier-extra-content").slideDown();
    });
    prestashop.on('changedCheckoutStep', (params) => {

        if (typeof params.event.currentTarget !== 'undefined') {
            $('.collapse', params.event.currentTarget).not('.show').not('.collapse .collapse').collapse('show');
        }
    });

    $('.checkout-step').each(function () {
        if ($(this).hasClass('-complete')) {
            $(this).find('.stepState span').hide();
            $(this).find('.stepState i').show().removeClass('d-none');
        } else if ($(this).hasClass('-current')) {
            $(this).find('.stepState span').show();
            $(this).find('.stepState i').hide();
        }
    });
    $('.step-edit, .checkout-step').on('click', function () {
        if ($(this).hasClass('-complete')) {
            $(this).find('.stepState span').hide();
            $(this).find('.stepState i').show().removeClass('d-none');
        }
    });

    const html = `
    <div class="form-group">
        <label class="" for="phone_mobile_verification">
            Verification téléphone mobile
        </label>
        <input class="form-control" name="phone_mobile_verification" type="text" value="" id="phone_mobile_verification" maxlength="32" required="true">
    </div>
    `;
    const htmlDelivery = `
    <div class="form-group">
        <label class="" for="phone_mobile_verification">
            Verification téléphone mobile
        </label>
        <input class="form-control" name="phone_mobile_verification_seq" type="text" value="" id="phone_mobile_verification_seq">
    </div>
    `;

    const phone_mobile_input = $("input[name='phone_mobile']");
    const phone_mobile_delivery_input = $("input[name='phone_mobile_seq']");

    phone_mobile_input.parent().after(html);
    phone_mobile_delivery_input.parent().after(htmlDelivery);

    $("input[name='phone_mobile_verification']").on("change", function () {
        if ($(this).val() !== phone_mobile_input.val()) {
            phone_mobile_input[0].setCustomValidity('Le numéro de téléphone ne correspond pas');
            $(this)[0].setCustomValidity('Le numéro de téléphone ne correspond pas');
            $(this).addClass('is-invalid');
        } else {
            phone_mobile_input[0].setCustomValidity('');
            $(this)[0].setCustomValidity('');
            $(this).removeClass('is-invalid');
        }
    });

    $("input[name='phone_mobile_verification_seq']").on("change", function () {
        if ($(this).val() !== phone_mobile_delivery_input.val()) {
            phone_mobile_delivery_input[0].setCustomValidity('Le numéro de téléphone ne correspond pas');
            $(this)[0].setCustomValidity('Le numéro de téléphone ne correspond pas');
            $(this).addClass('is-invalid');
        } else {
            phone_mobile_delivery_input[0].setCustomValidity('');
            $(this)[0].setCustomValidity('');
            $(this).removeClass('is-invalid');
        }
    });

    $('.close').click(function () {
        $('.alert').hide();
    })

});

$(document).on('change', '.js-input-delivery:checked', (event) => {
    $('.js-label-delivery.selected').removeClass('selected');
    $('#js-' + $(this).attr('id')).addClass('selected');
    // On va regarder si le transporteur sélectionné est la livraison : si c'est le cas : on affiche le formulaire de création
    const transporteur = $(event.currentTarget);
    const divForm = transporteur.closest('.delivery_parent').siblings('.carrier-extra-content').children('#seq_delivery');
    if (divForm.length > 0) {
        // Le transporteur sélectionné est la livraison
        divForm.removeClass("d-none");
        // Il faut ajouter les controles html (required et type)
        const elementsForm = {
            "prenom": $('input[name="firstname"]'),
            "nom": $('input[name="lastname"]'),
            "adresse1": $('input[name="address1"]'),
            "adresse2": $('input[name="address2"]'),
            "codepostal": $('input[name="postcode"]'),
            "ville": $('input[name="city"]'),
            "mobile": $('input[name="phone_mobile_seq"]')
        };
        for (let [key, value] of Object.entries(elementsForm)) {
            if (key !== "adresse2") {
                value.attr("required", true);
            }
            switch (key) {
                case "prenom":
                case "nom":
                    value.attr("maxlength", 255);
                    break;
                case "adresse1":
                case "adresse2":
                    value.attr("maxlength", 128);
                    break;
                case "codepostal":
                    value.attr("maxlength", 12);
                    break;
                case "ville":
                    value.attr("maxlength", 64);
                    break;
                case "mobile":
                    value.attr("maxlength", 32);
                    break;
            }
        }
    } else {
        // il n'est plus sélectionné, on cache le formulaire
        $("#seq_delivery").addClass("d-none");
        // on enlève les controles html (required et type)
        const elementsForm = {
            "prenom": $('input[name="firstname"]'),
            "nom": $('input[name="lastname"]'),
            "adresse1": $('input[name="address1"]'),
            "adresse2": $('input[name="address2"]'),
            "codepostal": $('input[name="postcode"]'),
            "ville": $('input[name="city"]'),
            "mobile": $('input[name="phone_mobile_seq"]')
        };
        for (let [key, value] of Object.entries(elementsForm)) {
            value.removeAttr("required");
            value.removeAttr("maxlength");
        }
    }
});

// $("#js-delivery").on("submit", function (e)
$('button[name="confirmDeliveryOption"]').on("click", function (e) {
    if ($('input[name="phone_mobile_seq"]').attr("required")) {
        e.preventDefault();
        const elementsForm = {
            "prenom": $('input[name="firstname"]')[0],
            "nom": $('input[name="lastname"]')[0],
            "adresse1": $('input[name="address1"]')[0],
            "adresse2": $('input[name="address2"]')[0],
            "codepostal": $('input[name="postcode"]')[0],
            "ville": $('input[name="city"]')[0],
            "mobile": $('input[name="phone_mobile_seq"]')[0]
        };
        let ok = true;
        for (let [key, value] of Object.entries(elementsForm)) {
            if (value.checkValidity() === false) {
                ok = false;
                value.classList.add("is-invalid");
            }
        }
        const valuesForm = {
            "prenom": $('input[name="firstname"]').val(),
            "nom": $('input[name="lastname"]').val(),
            "adresse1": $('input[name="address1"]').val(),
            "adresse2": $('input[name="address2"]').val(),
            "codepostal": $('input[name="postcode"]').val(),
            "ville": $('input[name="city"]').val(),
            "mobile": $('input[name="phone_mobile_seq"]').val()
        };
        if ($('input[name="phone_mobile_verification"]').hasClass('is-invalid') === false && ok === true) {
            $.ajax({
                url: 'module/seq_magasins/ajax',
                type: 'POST',
                cache: false,
                data: {
                    ajax: true,
                    data: valuesForm,
                    action: 'setDeliveryAddress',
                },
                success: function (message) {
                    const messageFormat = JSON.parse(message);
                    if (messageFormat.success) {
                        // on va set le carrier cart
                        $.ajax({
                            url: 'module/seq_magasins/ajax',
                            type: 'POST',
                            cache: false,
                            data: {
                                ajax: true,
                                data: {
                                    "delivery": true
                                },
                                action: 'setCarrierCart',
                            },
                            success: function (message) {
                                const messageFormat = JSON.parse(message);
                                if (messageFormat.success) {
                                    let input = $("<input>")
                                        .attr("type", "hidden")
                                        .attr("name", "confirmDeliveryOption").val("1");
                                    $("#js-delivery").append(input);
                                    $("#js-delivery").submit();
                                }
                            }
                        });
                    }
                }
            });
        }
    } else {
        e.preventDefault();
        // on va set le carrier cart
        $.ajax({
            url: 'module/seq_magasins/ajax',
            type: 'POST',
            cache: false,
            data: {
                ajax: true,
                data: {
                    "delivery": false
                },
                action: 'setCarrierCart',
            },
            success: function (message) {
                const messageFormat = JSON.parse(message);
                if (messageFormat.success) {
                    let input = $("<input>")
                        .attr("type", "hidden")
                        .attr("name", "confirmDeliveryOption").val("1");
                    $("#js-delivery").append(input);
                    $("#js-delivery").submit();
                }
            }
        });
    }
    return true;
});

// $('#submitSeqDelivery').on("click", function (e) {
//     e.preventDefault();
//     const elementsForm = {
//         "prenom": $('input[name="firstname"]')[0],
//         "nom": $('input[name="lastname"]')[0],
//         "adresse1": $('input[name="address1"]')[0],
//         "adresse2": $('input[name="address2"]')[0],
//         "codepostal": $('input[name="postcode"]')[0],
//         "ville": $('input[name="city"]')[0],
//         "mobile": $('input[name="phone_mobile_seq"]')[0]
//     };
//     let ok = true;
//     for (let [key, value] of Object.entries(elementsForm)) {
//         if (value.checkValidity() === false) {
//             ok = false;
//             value.classList.add("is-invalid");
//         }
//     }
//     const valuesForm = {
//         "prenom": $('input[name="firstname"]').val(),
//         "nom": $('input[name="lastname"]').val(),
//         "adresse1": $('input[name="address1"]').val(),
//         "adresse2": $('input[name="address2"]').val(),
//         "codepostal": $('input[name="postcode"]').val(),
//         "ville": $('input[name="city"]').val(),
//         "mobile": $('input[name="phone_mobile_seq"]').val()
//     };
//     if ($('input[name="phone_mobile_verification"]').hasClass('is-invalid') === false && ok === true) {
//         $.ajax({
//             url: 'module/seq_magasins/ajax',
//             type: 'POST',
//             cache: false,
//             data: {
//                 ajax: true,
//                 data: valuesForm,
//                 action: 'setDeliveryAddress',
//             },
//             success: function (message) {
//                 const messageFormat = JSON.parse(message);
//                 if (messageFormat.success) {
//                     $('#modalDelivery').modal('hide');
//                 } else {

//                 }
//                 // residence = messageFormat.residence;
//                 // $('.residenceName').text(residence);
//                 // $('#modalCenter').modal('hide');
//             }
//         });
//     }
// });

$(document).on('click', '.js-checkout-step-header', (event) => {
    let stepIdentifier = $(event.currentTarget).data('identifier');
    $('#' + stepIdentifier).addClass('-current');
    $('#content-' + stepIdentifier).collapse('show').scrollTop();
});



// WEBPACK FOOTER //
// ./js/checkout.js